import { Code, ConnectError, Interceptor } from '@connectrpc/connect';
import { inject } from '@angular/core';
import { AuthStateService } from '@core/services/auth/auth-state';

export function GrpcAuthInterceptor(): Interceptor {
  const auth = inject(AuthStateService);

  return (next) => async (req) => {
    const token = auth.token();
    if (token) {
      req.header.set('Authorization', `Bearer ${token}`);
    }

    try {
      return await next(req);
    } catch (e) {
      const isAuthMethod =
        req.service.typeName === 'AuthData' && req.method.name === 'RefreshSession';

      if (!isAuthMethod && e instanceof ConnectError && e.code === Code.Unauthenticated) {
        const ok = await auth.refreshTokens();
        if (!ok) {
          auth.logout();
          throw e;
        }

        const newToken = auth.token();
        if (!newToken) {
          auth.logout();
          throw e;
        }

        req.header.set('Authorization', `Bearer ${newToken}`);
        return await next(req);
      }

      throw e;
    }
  };
}
